// PARA-106 §7 (UI-архитектура) — i18n-поток admin-панели: RU/EN, один
// namespace common (упрощение относительно 4 языков/5 namespace во
// frontend/src/i18n — экранов существенно меньше, см. story "Архитектурные
// решения" п.5). Локаль интерфейса админки — чисто клиентская UI-настройка,
// не связана с AppSettings.supported_locales (данные для пользователей mini
// app, управляются через SettingsPage → LocalesTab).
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './en/common.json';
import ruCommon from './ru/common.json';

export const SUPPORTED_LOCALES = ['ru', 'en'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const FALLBACK_LOCALE: SupportedLocale = 'en';

// Отдельный ключ от frontend/ (paraparapam:locale) и от admin-токена
// (sessionStorage['admin_access_token']) — исключает пересечение состояния
// между тремя модулями монорепо.
export const LOCALE_STORAGE_KEY = 'paraparapam-admin:locale';

function isSupportedLocale(value: string | undefined): value is SupportedLocale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function getStoredLocale(): SupportedLocale | null {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY) ?? undefined;
  return isSupportedLocale(stored) ? stored : null;
}

/** Сохранённый выбор имеет приоритет над navigator.language (не Telegram —
 * admin-панель открывается в обычном браузере, не в Telegram WebView). */
export function guessInitialLocale(): SupportedLocale {
  const stored = getStoredLocale();
  if (stored) {
    return stored;
  }
  const browserLocale = navigator.language?.slice(0, 2);
  if (isSupportedLocale(browserLocale)) {
    return browserLocale;
  }
  return FALLBACK_LOCALE;
}

void i18n.use(initReactI18next).init({
  resources: {
    ru: { common: ruCommon },
    en: { common: enCommon },
  },
  lng: guessInitialLocale(),
  fallbackLng: FALLBACK_LOCALE,
  defaultNS: 'common',
  ns: ['common'],
  interpolation: { escapeValue: false },
});

/** Переключить локаль синхронно и сохранить как явный выбор администратора. */
export function applyLocale(locale: SupportedLocale): void {
  void i18n.changeLanguage(locale);
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}

export default i18n;
